import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Autocomplete, Box, Button, Card, CardContent, Container, Divider, Grid, TableBody, TextField, Typography } from "@mui/material";
import { ContextNotification, severitys } from '../../../App';
import { ContextUserInfo } from '../MainPanel';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import BeatLoading from '../../../Components/Loader/BeatLoader';
import staticVariablesApi from '../../../api/staticVariablesApi';
import helper from '../../../helper';
import guestRequestApi from '../../../api/guestRequestApi';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import CustomDateInput from '../../../Components/CustomDateInput';
import moment from 'jalali-moment'
import enumMapper from '../../../enumMapper';
import stationApi from '../../../api/stationApi';
import CheckboxListFlex from './CheckboxListFlex';
import guestServicesDetailsApi from '../../../api/guestServicesDetailsApi';

const AddGuestRequestForm = ({ groupInfo, refreshGrid }) => {
    const { open, setOpen } = useContext(ContextNotification);
    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const [mainCityDropDown, setMainCityDropDown] = useState([])
    const [hotelByCityDropDown, setHotelByCityDropDown] = useState([])
    const [selectedCity, setSelectedCity] = useState(null)

    const [guestServicesDropDown, setGuestServicesDropDown] = useState([])
    const [guestServiceTypeDropDown, setGuestServiceTypeDropDown] = useState([])
    const [stationConsistencyByCountryDropDown, setStationConsistencyByCountryDropDown] = useState([])
    const [originCities, setOriginCities] = useState([])
    const [destCities, setDestCities] = useState([])

    const [rows, setRows] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [loadingRows, setLoadingRows] = useState(false);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);

    const schema = yup.object().shape({
        selectPassengersId: yup.array().default([]).min(1, 'حداقل یک میهمان انتخاب نمایید'),
        cityConsistency: yup.string().when("guestServices", {
            is: (val) => (val?.toString() !== enumMapper.GuestServices.Visa.toString() && val?.toString() !== enumMapper.GuestServices.Flight.toString()),
            then: () => yup.string().required("شهر را انتخاب نمایید"),
        }),
        guestServices: yup.string().required("سرویس را انتخاب نمایید"),

        guestServiceType: yup.string().when("guestServices", {
            is: (val) => (val?.toString() !== enumMapper.GuestServices.Visa.toString()),
            then: () => yup.string().required("نوع سرویس را انتخاب نمایید"),
        }),
       
        from: yup.string().when("guestServices", {
            is: (val) => (val?.toString() !== enumMapper.GuestServices.Visa.toString()),
            then: () => yup.string().required("از تاریخ را انتخاب نمایید"),
        }),
         to: yup.string().when("guestServices", {
            is: (val) => (val?.toString() !== enumMapper.GuestServices.Visa.toString()),
            then: () => yup.string().required("تا تاریخ را انتخاب نمایید"),
        }),
        hotelId: yup.string().when("guestServices", {
            is: (val) => val?.toString() === enumMapper.GuestServices.Plan.toString(),
            then: () => yup.string().required("هتل را انتخاب نمایید"),
        }),
    }
    );
    const { register, handleSubmit, formState: { errors }, control, watch, setValue, resetField } = useForm({
        defaultValues: {

        },
        resolver: yupResolver(schema),
    });

    function GetGregorianDate(input) {
        let dateGregorian = null;
        if (input) {
            let date = new DateObject({
                date: input,
                calendar: persian,
                locale: persian_fa
            });

            var dateStr = date.year + '/' + date.month.number + '/' + date.day;
            dateGregorian = moment.from(dateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }
        return dateGregorian
    }

    const onSubmit = (data) => {
        const newData = {
            "guestGroupID": groupInfo.id,
            "guestServices": Number(data.guestServices),
            "guestServiceType": data.guestServices?.toString() === enumMapper.GuestServices.Visa.toString() ? enumMapper.GuestServices.Visa : Number(data.guestServiceType),
            "cityConsistency": Number(data.cityConsistency),
            "hotelId": data.hotelId,
            "selectPassengersId": data.selectPassengersId?.map(x => x.id), //arr
            "from": GetGregorianDate(data.from),
            "to": GetGregorianDate(data.to),
            "originStation": data.originStation?.id,
            "destinationStation": data.destinationStation?.id,
        }
        guestRequestApi.Add(newData).then(res => {
            if (res.data.success) {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                refreshGrid(true)
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
            else {
                setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
            }
        }
        ).finally(() => { setSubmitLoading(false); });
    };
    useEffect(() => {
        GetMainCityDropDown();
        GetServicesDropDown();
        StationConsistencyByCountryDropDown();
    }, []);

    const GetMainCityDropDown = () => {
        staticVariablesApi.GetMainCityDropDown()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data);
                setMainCityDropDown(arr.map((item) => {
                    return {
                        id: item.key,
                        label: item.value
                    };
                }))
            })
            .catch((error) => console.log(error));
    };

    const handleMainCityChanged = useCallback(async (id) => {
        resetField("hotelId");
        setHotelByCityDropDown([]);
        if (id) {
            setSelectedCity(id)
            const serviceTypes = await fetchHotelByCity(id);
            setHotelByCityDropDown(
                serviceTypes.map((o) => {
                    return {
                        id: o.key,
                        label: o.value
                    };
                })
            );
        }
    }, []);

    const fetchHotelByCity = async (cityConsistency) => {
        try {
            let res = await guestServicesDetailsApi.GetGuestHotelByCityDropDown(cityConsistency);
            if (res.status == 200) {
            }
            const arr = helper.DictionayToList(res.data.data)
            return arr;
        }
        catch (err) {
            console.error(err);
        }
    };

    const handleHotelChanged = () => { }

    const GetServicesDropDown = () => {
        guestServicesDetailsApi.GetServicesDropDown()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data);
                setGuestServicesDropDown(arr.map((item) => {
                    return {
                        id: item.key,
                        label: item.value
                    };
                }))
            })
            .catch((error) => console.log(error));
    };

    const StationConsistencyByCountryDropDown = () => {
        stationApi.StationConsistencyByCountryDropDown()
            .then((res) => {
                setStationConsistencyByCountryDropDown(res.data)
            })
            .catch((error) => console.log(error));
    };

    const handleGuestServiceChanged = useCallback(async (id) => {
        resetField("guestServiceType");
        setGuestServiceTypeDropDown([]);
        if (id) {
            const serviceTypes = await fetchGuestServiceType(id);
            setGuestServiceTypeDropDown(
                serviceTypes.map((o) => {
                    return {
                        id: o.key,
                        label: o.value
                    };
                })
            );
        }
    }, []);
    const fetchGuestServiceType = async (id) => {
        try {
            let res = await guestServicesDetailsApi.GetServicesTypeDropDown(id);
            if (res.status == 200) {
            }
            const arr = helper.DictionayToList(res.data.data)
            return arr;
        }
        catch (err) {
            console.error(err);
        }
    };
    const handleGuestServiceTypeChanged = (selectedCountry) => {
        const originCities = selectedCountry
            ? getOriginAndDestination(parseInt(selectedCountry), stationConsistencyByCountryDropDown?.items)?.origin
            : [];
        setOriginCities(originCities);

        const destCities = selectedCountry
            ? getOriginAndDestination(parseInt(selectedCountry), stationConsistencyByCountryDropDown?.items)?.destination
            : [];
        setDestCities(destCities)
    }

    function getOriginAndDestination(input, items) {
        const toArray = (list) =>
            Object.entries(list).map(([id, label]) => ({
                id: Number(id),
                label
            }));

        const country0 =
            items.find(item => item.country === 0)?.list || {};

        const country1 =
            items.find(item => item.country === 1)?.list || {};

        if (input === 40) {
            return {
                origin: toArray(country0),
                destination: toArray(country1)
            };
        }

        if (input === 41) {
            return {
                origin: toArray(country1),
                destination: toArray(country0)
            };
        }

        return null;
    }

    const RefreshGrid = (result) => {
        if (result)
            setRefresh(old => !old);
    }

    const resetForm = () => {

    }

    return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        
        {/* سرویس */}
        <Grid item xs={12} md={6}>
          <RHFAutocomplete
            control={control}
            options={guestServicesDropDown ?? []}
            name="guestServices"
            placeholder="سرویس"
            onChange={handleGuestServiceChanged}
            error={!!errors?.guestServices}
            helperText={errors?.guestServices?.message}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              }
            }}
          />
        </Grid>
        {/* شهر */}
       {(watch("guestServices") !== enumMapper.GuestServices.Visa.toString() && watch("guestServices") !== enumMapper.GuestServices.Flight.toString() ) && <Grid item xs={12} md={6}>
          <RHFAutocomplete
            control={control}
            options={mainCityDropDown ?? []}
            name="cityConsistency"
            placeholder="شهر"
            onChange={handleMainCityChanged}
            error={!!errors?.cityConsistency}
            helperText={errors?.cityConsistency?.message}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              }
            }}
          />
        </Grid>
}


        {/* نوع سرویس */}
        {watch("guestServices") !== enumMapper.GuestServices.Visa.toString() && (
          <Grid item xs={12} md={6}>
            <RHFAutocomplete
              loading={watch("guestServices") && !guestServiceTypeDropDown?.length}
              control={control}
              options={guestServiceTypeDropDown ?? []}
              name="guestServiceType"
              placeholder="نوع سرویس"
              onChange={handleGuestServiceTypeChanged}
              disabled={!guestServiceTypeDropDown?.length}
              error={!!errors?.guestServiceType}
              helperText={errors?.guestServiceType?.message}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                }
              }}
            />
          </Grid>
        )}

        {/* هتل */}
        {watch("guestServices") === enumMapper.GuestServices.Plan.toString() && (
          <Grid item xs={12} md={6}>
            <RHFAutocomplete
              loading={
                watch("cityConsistency") &&
                watch("guestServices") === enumMapper.GuestServices.Plan &&
                !hotelByCityDropDown?.length
              }
              control={control}
              options={hotelByCityDropDown ?? []}
              name="hotelId"
              placeholder="هتل"
              onChange={handleHotelChanged}
              disabled={!hotelByCityDropDown?.length}
              error={!!errors?.hotelId}
              helperText={errors?.hotelId?.message}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                }
              }}
            />
          </Grid>
        )}

        {/* اعضا */}
        <Grid item xs={12}>
          <Box
            sx={{
              p: 2,
              border: "1px solid #eee",
              borderRadius: 2
            }}
          >
            <CheckboxListFlex
              name="selectPassengersId"
              control={control}
              items={groupInfo?.allMembers?.map((r) => ({
                id: r.id,
                label: r.name + " " + r.family,
              }))}
              label="اعضا"
              direction="row"
              spacing={1}
              onChange={() => {}}
            />
          </Box>
        </Grid>

{
     watch("guestServices") !== enumMapper.GuestServices.Visa.toString() && <>  
        <Grid item xs={12} md={6}>
          <Controller
            control={control}
            name="from"
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => (
              <DatePicker
                value={value || ""}
                onChange={(date) => {
                  onChange(date?.isValid ? date : "");
                }}
                format="YYYY/MM/DD"
                calendar={persian}
                locale={persian_fa}
                calendarPosition="bottom-right"
                render={
                  <CustomDateInput
                    label="از"
                    error={!!errors?.from}
                    helperText={errors?.from?.message}
                  />
                }
              />
            )}
          />
        </Grid>

        
        <Grid item xs={12} md={6}>
          <Controller
            control={control}
            name="to"
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => (
              <DatePicker
                value={value || ""}
                onChange={(date) => {
                  onChange(date?.isValid ? date : "");
                }}
                format="YYYY/MM/DD"
                calendar={persian}
                locale={persian_fa}
                calendarPosition="bottom-right"
                render={
                  <CustomDateInput
                    label="تا"
                    error={!!errors?.to}
                    helperText={errors?.to?.message}
                  />
                }
              />
            )}
          />
        </Grid>
        </>
}

      </Grid>

      {/* بخش پرواز */}
      {watch("guestServices") === enumMapper.GuestServices.Flight.toString() && (
        <>
          <Divider sx={{ my: 4 }} />

          <Grid container spacing={2}>

            <Grid item xs={12} md={6}>
              <Controller
                name="originStation"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    options={originCities}
                    getOptionLabel={(o) => o?.label || ""}
                    disabled={!watch("guestServiceType")}
                    onChange={(_, value) => field.onChange(value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="ایستگاه مبدأ"
                        error={!!errors?.originStation}
                        helperText={errors?.originStation?.message}
                      />
                    )}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="destinationStation"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    options={destCities}
                    getOptionLabel={(o) => o?.label || ""}
                    disabled={!watch("guestServiceType")}
                    onChange={(_, value) => field.onChange(value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="ایستگاه مقصد"
                        error={!!errors?.destinationStation}
                        helperText={errors?.destinationStation?.message}
                      />
                    )}
                  />
                )}
              />
            </Grid>

          </Grid>
        </>
      )}

      {/* دکمه ثبت */}
      <Box textAlign="center" mt={5}>
        <Button
          type="submit"
          variant="contained"
          size="large"
          sx={{
            px: 6,
            py: 1.2,
            borderRadius: 3,
            fontWeight: 600
          }}
          disabled={submitLoading}
        >
          {submitLoading
            ? <BeatLoading loading color="#fff" size={8} />
            : "ثبت درخواست"}
        </Button>
      </Box>
    </form>

    )
}
export default AddGuestRequestForm;